export const sponsorExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Sponsor Name',
		render: s => (s?.user ? `${s.user.firstName || ''} ${s.user.lastName || ''}` : ''),
	},

	{
		label: 'Community',
		render: s => s?.hub?.name || '',
	},

	{
		label: 'Sanstha',
		render: s => s?.sanstha?.name || '',
	},
	{
		label: 'Recived Amount (Rs)',
		render: s => s?.amount || 0,
	},
	{
		label: 'Start Date',
		render: s => (s?.startDate ? new Date(s.startDate).toLocaleDateString() : ''),
	},

	{
		label: 'End Date',
		render: s => (s?.endDate ? new Date(s.endDate).toLocaleDateString() : ''),
	},
]
